/* ============================================================
   HARDWARE CENTRE UK — storefront interactivity
   Operates on Liquid-rendered markup (no hard-coded data).
   ============================================================ */
(function () {
  'use strict';
  const $ = (s, el) => (el || document).querySelector(s);
  const $$ = (s, el) => [...(el || document).querySelectorAll(s)];

  /* ---------- MEGA MENU (hover + keyboard + click) ---------- */
  let megaTimer;
  $$('.hcuk .navlist > li[data-mega]').forEach((li) => {
    li.addEventListener('mouseenter', () => {
      clearTimeout(megaTimer);
      $$('.hcuk .navlist > li').forEach((x) => x.classList.remove('open'));
      li.classList.add('open');
    });
    li.addEventListener('mouseleave', () => {
      megaTimer = setTimeout(() => li.classList.remove('open'), 120);
    });
    const btn = $('.navlink', li);
    if (btn) {
      btn.addEventListener('focus', () => {
        $$('.hcuk .navlist > li').forEach((x) => x.classList.remove('open'));
        li.classList.add('open');
      });
      btn.addEventListener('click', (e) => {
        if (btn.tagName === 'BUTTON') {
          e.preventDefault();
          li.classList.toggle('open');
        }
      });
    }
  });

  /* ---------- MOBILE NAV ACCORDION ---------- */
  $$('.hcuk .macc > button').forEach((b) =>
    b.addEventListener('click', () => {
      const macc = b.parentElement;
      const panel = macc.querySelector('.macc__panel');
      const isOpen = macc.classList.toggle('open');
      // expand to the panel's real content height so no submenu items are clipped
      if (panel) panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '';
    })
  );

  /* ---------- PRODUCT PAGE ACCORDIONS ---------- */
  $$('.hcuk .pdp__acc-head').forEach((b) =>
    b.addEventListener('click', () => b.parentElement.classList.toggle('open'))
  );

  /* ---------- FAQ ACCORDIONS ---------- */
  $$('.hcuk .faq__q').forEach((b) =>
    b.addEventListener('click', () => b.closest('.faq__item').classList.toggle('open'))
  );

  /* ---------- COLLECTION: sort, filters, mobile toggle ---------- */
  const colSort = $('.hcuk [data-col-sort]');
  if (colSort)
    colSort.addEventListener('change', function () {
      const u = new URL(window.location);
      u.searchParams.set('sort_by', colSort.value);
      u.searchParams.delete('page');
      window.location = u.toString();
    });
  const colForm = $('.hcuk [data-col-filter-form]');
  if (colForm)
    $$('input[type="checkbox"]', colForm).forEach((el) =>
      el.addEventListener('change', () =>
        colForm.requestSubmit ? colForm.requestSubmit() : colForm.submit()
      )
    );
  const colFT = $('.hcuk [data-col-filters-toggle]');
  if (colFT)
    colFT.addEventListener('click', () => {
      const f = $('#colFilters');
      if (f) f.classList.toggle('open');
    });

  /* ---------- DRAWERS / SCRIM ---------- */
  const scrim = $('.hcuk-scrim');
  let _lockScrollY = 0;
  function lockBody() {
    _lockScrollY = window.scrollY || window.pageYOffset || 0;
    const b = document.body.style;
    b.position = 'fixed';
    b.top = -_lockScrollY + 'px';
    b.left = '0';
    b.right = '0';
    b.width = '100%';
    b.overflow = 'hidden';
  }
  function unlockBody() {
    const b = document.body.style;
    b.position = '';
    b.top = '';
    b.left = '';
    b.right = '';
    b.width = '';
    b.overflow = '';
    window.scrollTo(0, _lockScrollY);
  }
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('show');
    if (scrim) scrim.classList.add('show');
    lockBody();
  }
  function closeDrawers() {
    $$('.hcuk-drawer').forEach((d) => d.classList.remove('show'));
    if (scrim) scrim.classList.remove('show');
    unlockBody();
  }
  $$('[data-hcuk-open]').forEach((btn) =>
    btn.addEventListener('click', () => openDrawer($('#' + btn.getAttribute('data-hcuk-open'))))
  );
  $$('[data-hcuk-close]').forEach((btn) => btn.addEventListener('click', closeDrawers));
  if (scrim) scrim.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      $$('.hcuk .navlist > li').forEach((x) => x.classList.remove('open'));
      closeDrawers();
    }
  });

  /* ---------- TOAST ---------- */
  let toastT;
  const toast = $('.hcuk-toast');
  function showToast(msg) {
    if (!toast) return;
    const m = $('[data-toast-msg]', toast);
    if (m) m.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastT);
    toastT = setTimeout(() => toast.classList.remove('show'), 2600);
  }

  /* ---------- BASKET ----------
     Real products (data-variant-id) add to the Shopify cart and open
     Horizon's cart drawer. Placeholder cards use the demo basket. */
  const fmt = (n) => '£' + Number(n).toFixed(2);
  let basket = [];
  const basketBody = $('#hcukBasketBody');
  const basketFoot = $('#hcukBasketFoot');
  const basketCount = $('[data-basket-count]');
  const basketTotal = $('[data-basket-total]');

  function renderBasket() {
    if (!basketBody) return;
    if (!basket.length) {
      basketBody.innerHTML =
        '<div class="bd__empty"><svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 8h14l-1.2 11a2 2 0 01-2 1.8H8.2a2 2 0 01-2-1.8z"/><path d="M9 8V6a3 3 0 016 0v2"/></svg><p>Your basket is empty.</p></div>';
      if (basketFoot) basketFoot.style.display = 'none';
      return;
    }
    basketBody.innerHTML = basket
      .map(
        (i) =>
          '<div class="bd__item"><div class="bd__thumb">' +
          (i.img ? '<img src="' + i.img + '" alt="">' : '') +
          '</div><div class="bd__meta"><b>' +
          i.title +
          '</b><span>' +
          (i.sku || '') +
          ' · Qty ' +
          i.qty +
          '</span></div><span class="bd__price">' +
          fmt(i.price * i.qty) +
          '</span></div>'
      )
      .join('');
    if (basketTotal) basketTotal.textContent = fmt(basket.reduce((s, i) => s + i.price * i.qty, 0));
    if (basketFoot) basketFoot.style.display = 'block';
  }

  function addToBasket(d) {
    const ex = basket.find((i) => i.sku === d.sku && i.title === d.title);
    if (ex) ex.qty++;
    else basket.push(Object.assign({}, d, { qty: 1 }));
    if (basketCount) basketCount.textContent = basket.reduce((s, i) => s + i.qty, 0);
    renderBasket();
  }

  /* Real Shopify add-to-cart that opens & refreshes Horizon's cart drawer.
     Fires the StandardEvents.cartLinesUpdate event Horizon listens for. */
  function hcukCartAdd(variantId, quantity, title) {
    variantId = Number(variantId);
    quantity = parseInt(quantity, 10) || 1;
    const ids = [];
    $$('cart-items-component').forEach((c) => {
      if (c.dataset.sectionId) ids.push(c.dataset.sectionId);
    });
    const body = { items: [{ id: variantId, quantity: quantity }] };
    if (ids.length) {
      body.sections = ids.join(',');
      body.sections_url = window.location.pathname;
    }
    let resolveFn;
    const promise = new Promise((res) => {
      resolveFn = res;
    });
    let ev;
    try {
      ev = new Event('shopify:cart:lines-update', { bubbles: true });
    } catch (e) {
      ev = document.createEvent('Event');
      ev.initEvent('shopify:cart:lines-update', true, false);
    }
    ev.action = 'add';
    ev.promise = promise;
    document.dispatchEvent(ev);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((r) => r.json().then((j) => ({ ok: r.ok, j: j })))
      .then((res) => {
        if (!res.ok || res.j.status) {
          resolveFn({ detail: { didError: true } });
          showToast((res.j && res.j.description) || 'Could not add to basket');
          return;
        }
        return fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            $$('[data-basket-count]').forEach((el) => {
              el.textContent = cart.item_count;
            });
            resolveFn({
              cart: cart,
              detail: {
                items: cart.items,
                sections: res.j.sections,
                source: 'hcuk',
                didError: false,
                itemCount: quantity,
              },
            });
            showToast((title ? '“' + title + '” ' : '') + 'added to basket');
          });
      })
      .catch(() => {
        resolveFn({ detail: { didError: true } });
        showToast('Could not add to basket');
      });
  }
  window.hcukCartAdd = hcukCartAdd;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.hcuk .pcard__add');
    if (!btn) return;
    const variantId = btn.dataset.variantId;

    if (variantId) {
      // Real Shopify product → real cart drawer
      e.preventDefault();
      hcukCartAdd(variantId, 1, btn.dataset.title);
    } else {
      // Placeholder/demo card
      addToBasket({
        title: btn.dataset.title,
        sku: btn.dataset.sku,
        price: +btn.dataset.price || 0,
        img: btn.dataset.img || '',
      });
      showToast('“' + btn.dataset.title + '” added to basket');
    }

    btn.classList.add('added');
    const html = btn.innerHTML;
    btn.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M5 12l5 5L20 6"/></svg> Added';
    setTimeout(() => {
      btn.classList.remove('added');
      btn.innerHTML = html;
    }, 1400);
  });
  renderBasket();

  /* ---------- SCROLL REVEAL ---------- */
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (ents) => {
        ents.forEach((en) => {
          if (en.isIntersecting) {
            en.target.style.opacity = 1;
            en.target.style.transform = 'none';
            io.unobserve(en.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    $$('.hcuk .cat-card, .hcuk .pcard, .hcuk .brand-tile').forEach((el, i) => {
      el.style.opacity = 0;
      el.style.transform = 'translateY(14px)';
      el.style.transition =
        'opacity .5s ' + (i % 8) * 40 + 'ms ease, transform .5s ' + (i % 8) * 40 + 'ms ease';
      io.observe(el);
    });
  }
})();
